import React, { useEffect, useState } from 'react'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Space, Tabs } from 'antd'
import { LoadingView } from 'Components/modal'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { PosMenu } from 'helpers/constanst'
import { UserList } from './components'
import { MerchantPackageListReq } from 'Store/pos/types'
import { getMerchantPackageListAPI } from 'Store/pos/api'
import { selectIsPackageEnterprise, selectMerchantPackageList } from 'Store/pos/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { CheckCircleFilled } from '@ant-design/icons'
import { PrimaryButton } from 'Components/button'
import PackageList from './components/PackageList'
import { appConfig } from 'config'
import TerminalConfig from './components/TerminalConfig'
import PaymentConfig from './components/PaymentConfig'
import { useNavigate } from 'react-router-dom'
const PackageImg = `${appConfig.publicAssetEndpoint}/etc/package-pos.png`
const { TabPane } = Tabs

type Props = {} & ReduxProps

const Pos: React.FunctionComponent<Props> = props => {
  const { currentUser, merchantPackageList, isPackageEnterprise } = props
  const dispatch = useDispatch()
  const history = useNavigate()

  const [activeTab, setActiveTab] = useState(PosMenu.USER as string)
  const isRegistered = merchantPackageList.data.length > 0
  const showCashdrawerManagement = isPackageEnterprise

  const onGetMerchantPackageList = (): void => {
    const req: MerchantPackageListReq = {}
    dispatch(getMerchantPackageListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetMerchantPackageList()
    }
  }, [])

  const onChangeTab = (key: string): void => {
    setActiveTab(key)
  }

  const getTab = () => {
    return (
      <Tabs defaultActiveKey={activeTab} onChange={onChangeTab} type="line">
        <TabPane tab="จัดการข้อมูลผู้ใช้งาน" key={PosMenu.USER}></TabPane>
        <TabPane tab="แพ็กเกจของคุณ" key={PosMenu.PACKAGE}></TabPane>
        {showCashdrawerManagement && <TabPane tab="ตั้งค่าเครื่องเทอมินอล" key={PosMenu.TERMINAL}></TabPane>}
        {/* {showPaymentSetting && (
          <TabPane tab="ตั้งค่าช่องทางการรับชำระเงิน" key={PosMenu.PAYMENT_CHANNEL}></TabPane>
        )} */}
      </Tabs>
    )
  }

  const gotoPackagePage = (): void => {
    history('/pos/packages')
  }

  return (
    <HomePageLayout
      selected="pos"
      title={isRegistered ? 'ระบบช่วยขายหน้าร้าน (Terminal)' : <Title>ระบบช่วยขายหน้าร้าน</Title>}
      // bgColor={'#fff'}
    >
      <LoadingView isShow={merchantPackageList.event.IsLoading} />
      <Row gutter={[16, 48]}>
        {isRegistered ? (
          <Col span={24}>
            {getTab()}
            {activeTab === PosMenu.USER && <UserList />}
            {activeTab === PosMenu.PACKAGE && <PackageList history={history} />}
            {activeTab === PosMenu.TERMINAL && <TerminalConfig />}
            {activeTab === PosMenu.PAYMENT_CHANNEL && <PaymentConfig />}
          </Col>
        ) : merchantPackageList.event.IsLoading ? (
          <span>{''}</span>
        ) : (
          <Col span={24}>
            {/* <Curve /> */}
            <TitleSecond>ที่จะช่วยให้ธุรกิจของคุณแข็งแกร่งขึ้น</TitleSecond>
            <MarginWrapper>
              <Row gutter={[16, 16]} align="middle" justify="center">
                <Col lg={12} xs={24}>
                  <ImgPackage src={PackageImg} />
                </Col>
                <Col lg={12} xs={24}>
                  <WrapperSpace align="start" direction="vertical" size="large">
                    {[
                      'ขายสินค้าหน้าร้านได้สะดวกยิ่งขึ้น',
                      'ตัดสต๊อกพร้อมกับขายออนไลน์ได้',
                      'รายงานยอดขาย และสินค้าขายดีแบบ วัน/เดือน/ปี',
                      'จัดชั้นวางของสินค้าได้ เพื่อความรวดเร็วในการค้นหาสินค้า',
                    ].map((item: string, index: number) => {
                      return (
                        <Space key={index} align="start">
                          <CheckIcon />
                          <List>{item}</List>
                        </Space>
                      )
                    })}
                  </WrapperSpace>
                </Col>
                <Col lg={6} xs={20}>
                  <MarginWrapper>
                    <PrimaryButton text={'ดูรายละเอียดแพ็กเกจ'} onClick={gotoPackagePage} />
                  </MarginWrapper>
                </Col>
              </Row>
            </MarginWrapper>
          </Col>
        )}
      </Row>
    </HomePageLayout>
  )
}

const Title = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h2sm};
`

const TitleSecond = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.drakGrey};
`

const ImgPackage = styled.img`
  width: 100%;
`

const MarginWrapper = styled.div`
  margin-top: 10px;
`
const WrapperSpace = styled(Space)`
  width: 100%;
`

const List = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title2};
  text-align: left;
`

const CheckIcon = styled(CheckCircleFilled)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h3};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    merchantPackageList: selectMerchantPackageList(state),
    isPackageEnterprise: selectIsPackageEnterprise(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(Pos)
